import React from 'react'

import { Fieldset, RadioButton } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import { getEmojiIcon } from '../../../../utils'
import type { FormValues } from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { EmojiInput } from '../EmojiInput'
import { MainInputs } from '../MainInputs'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
}

export const BadgeType = ({ form }: Props) => {
  if (form.values.badgeType === 'Verified') {
    return (
      <Fieldset.Row>
        <MainInputs form={form} verified />
      </Fieldset.Row>
    )
  }

  return (
    <>
      <Fieldset.Row>
        <RadioButton
          label="Icon and text"
          {...form.getFieldProps(FormFields.badgeType)}
          checkedValue="IconAndText"
        />
      </Fieldset.Row>
      {form.values.badgeType === 'IconAndText' && (
        <Fieldset.Row inner>
          <MainInputs form={form} />
        </Fieldset.Row>
      )}
      <Fieldset.Row>
        <RadioButton
          label="Icon only"
          {...form.getFieldProps(FormFields.badgeType)}
          checkedValue="IconOnly"
        />
      </Fieldset.Row>
      {form.values.badgeType === 'IconOnly' && (
        <Fieldset.Row inner>
          <EmojiInput
            emoji={getEmojiIcon(form.values.emoji)}
            onChange={(emoji) => {
              if (emoji.type === 'ImageResource') {
                form.setFieldValue(FormFields.emoji, {
                  type: 'ImageResource',
                  url: emoji.url,
                  imageResourceId: emoji.imageResourceId,
                })
              } else {
                form.setFieldValue(FormFields.emoji, {
                  type: 'Emoji',
                  emojiIcon: emoji.emojiIcon,
                })
              }
            }}
          />
        </Fieldset.Row>
      )}
    </>
  )
}
